<div class="progress-container">
  <div class="progress-bar">
    <div class="progress-fill" [style.width.%]="progressPercentage"></div>
  </div>
  <div class="progress-text">{{ currentOffset }} / {{ totalOffset }}</div>
</div>
